export default __webpack_public_path__ + "static/media/WP.0583e2d3.svg";